<template>
  <main id="contents" class="top-padding-dark">
    <SearchTopTagGroup :tag-data-list="topTagList" @click-fn="clickTag" />

    <div v-if="!isLoading" class="wrap">
      <div class="search-body">
        <SearchTagMultiBand
          v-if="isCategoryAll"
          :page-type="listType"
          :tag-data-list="tagData"
        />

        <SearchTagList
          v-else
          :category="category"
          :page-type="listType"
          :tag-data-list="tagData"
        />
      </div>
    </div>
  </main>
</template>

<script>
  import _ from 'lodash'
  import { getTagsList } from '@/common/utils/request'
  import { scrollTop } from '@/common/utils/common'
  import { mapMutations } from 'vuex'
  import { SET_CURRENT_MENU } from '@/common/resources/const'
  import { PATH_NAME_SEARCH_TAG_GROUP } from '@/common/resources/router.const'
  import SearchTopTagGroup from '@/components/search/view/SearchTopTagGroup'
  import SearchTagMultiBand from '@/components/search/data/SearchTagMultiBand'
  import SearchTagList from '@/components/search/data/SearchTagList'

  export default {
    name: 'SearchTagGroupResult',
    components: {
      SearchTopTagGroup,
      SearchTagMultiBand,
      SearchTagList,
    },
    data() {
      return {
        isLoading: true,
        isDataLoading: true,
        tagCode: '',
        tagText: '',
        category: 'all',
        listType: '', // as similar as page type | 'vod' | 'movie
        contentid: '',
        topTagList: [], // content id 에 있는 모든 tagList | object []
        tagData: [], // 현재 active tag | [{ selected: 'y' | 'n', taggroup: string, text: string, value: string}]
      }
    },
    computed: {
      isCategoryAll() {
        return this.category === 'all'
      },
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU]),
      fromQuery(key, defaultValue) {
        return _.get(this.$route, ['query', key], defaultValue)
      },
      updateTagData() {
        this.tagData = _.filter(
          this.topTagList,
          (tag) => tag.value === this.tagCode,
        )
      },
      clickTag(tag) {
        this.updateTagData()
        this.$router
          .push({
            name: PATH_NAME_SEARCH_TAG_GROUP,
            query: {
              tag: _.get(tag, 'value', ''),
              text: _.get(tag, 'text', 'text'),
              mtype: _.get(this.$route, 'query.mtype', ''),
              category: this.category,
              list: this.listType,
              contentid: this.contentid,
              page: 1,
            },
          })
          .catch(() => {})
      },
      setTagData(data) {
        const { taggrouplist: tagGroupList = [] } = data

        this.topTagList = tagGroupList
        this.updateTagData()
      },
      async fetchTopTagList() {
        this.isDataLoading = true

        try {
          const { data } = await getTagsList({
            type: this.listType,
            contentid: this.contentid,
            tag: this.tagCode,
          })
          this.setTagData(data)
        } catch (error) {
          console.error(error)
        } finally {
          this.isLoading = false
          this.isDataLoading = false
        }
      },
      initialize() {
        this.tagCode = this.fromQuery('tag')
        this.tagText = this.fromQuery('text')
        this.listType = this.fromQuery('list')
        this.category = this.fromQuery('category', 'all')
        this.contentid = this.fromQuery('contentid')
        this.isLoading = true
      },
      resetData() {
        this.initialize()
        this.fetchTopTagList()
      },
    },
    watch: {
      $route() {
        scrollTop()
        this.resetData()
      },
    },
    created() {
      this[SET_CURRENT_MENU]('search')
      this.initialize()
      this.fetchTopTagList()
    },
  }
</script>
